







import Vue from 'vue'
import roles from '@/services/Roles'

export default Vue.extend({
  name: 'StaffOnly',
  props: {
    restaurantId: String,
  },
  data() {
    return {
      authorized: true,
    }
  },
  async created() {
    this.authorized = await roles.isStaff(this.restaurantId)
  },
})
